import { render, staticRenderFns } from "./MissionDetail.vue?vue&type=template&id=0f72c2c4&scoped=true"
import script from "./MissionDetail.vue?vue&type=script&lang=js"
export * from "./MissionDetail.vue?vue&type=script&lang=js"
import style0 from "./MissionDetail.vue?vue&type=style&index=0&id=0f72c2c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f72c2c4",
  null
  
)

export default component.exports